// 繁體中文語言包
export default {
  common: {
    home: '首頁',
    products: '產品中心',
    application: '應用領域',
    quality: '質量管理',
    about: '關於我們',
    contact: '聯繫我們',
    search: '搜索',
    searchPlaceholder: '請輸入關鍵詞',
    login: '登錄',
    logout: '退出登錄',
    more: '查看更多',
    viewFile: '查看文件',
    downloadFile: '下載文件',
    onlineHelp: '選型手册下載',
    en: 'EN',
    simplifiedChinese: '中文（簡體）',
    traditionalChinese: '中文（繁體）',
    english: 'English',
    noData: '暫無數據',
    loading: '加載中...',
    noFiles: '暫無文件'
  },
  nav: {
    home: '首頁',
    products: '產品中心',
    application: '應用領域',
    applicationIndustry: '行業應用',
    applicationManual: '產品應用手冊',
    quality: '品質管理',
    newsCenter: '新聞中心',
    companyNews: '公司動態',
    techCategory: '技術分類',
    about: '關於我們',
    investor: '投資者關係',
    contact: '聯繫我們',
    memsSensor: 'MEMS感測器',
    memsSiliconMicrophone: 'MEMS矽麥克風感測器晶片'
  },
  home: {
    powerProducts: '功率產品',
    audioProducts: '音頻產品',
    audioSignalChainChips: '音頻信號鏈芯片',
    aboutUs: '關於我們',
    coreProducts: '核心產品',
    coreProductsDesc: '業界領先產品',
    seniorIntroduction: '高層介紹',
    seniorIntroductionDesc: '高層介紹',
    newsInformation: '新聞資訊',
    newsInformationDesc: '新聞資訊',
    technicalSharing: '技術分享',
    technicalSharingDesc: '技術分享',
    greenEnergy: '綠色能源',
    communication: '通信',
    smartLife: '智能生活',
    automotive: '汽車',
    computing: '計算',
    industry: '工業',
    sicMosfet: '碳化硅MOSFET',
    automotivePower: '汽車功率半導體',
    memsMicrophone: 'MEMS硅麥克風傳感器芯片',
    sicMosfetDesc1: '產品性能指標達到全球第一梯隊',
    sicMosfetDesc2: '8英寸SiC MOS',
    sicMosfetDesc3: '汽車、充電樁、光伏儲能、服務器電源、工業領域大批量出貨',
    sicMosfetDesc4: '芯聯集成供應鏈戰略支持',
    automotivePowerDesc1: '國內產品佈局最全面的功率半導體平台型企業',
    automotivePowerDesc2: 'SiC MOS、IGBT、硅基MOS、FRD等均在車載客戶中實現大批量出貨',
    automotivePowerDesc3: '覆蓋汽車電驅、電池、底盤、熱管理、車身、座艙等全應用領域',
    automotivePowerDesc4: '多家全球頂級車載客戶核心國產功率半導體供應商',
    memsMicrophoneDesc1: '累計出貨數量超過20億顆，位居全球前列',
    memsMicrophoneDesc2: '智能終端頭部品牌全覆蓋'
  },
  about: {
    title: 'ALKAIDSEMI',
    slogan: '共創智能與可持續的未來',
    corporateCulture: '企業文化',
    corporateCultureTitle: 'Corporate<br>Culture',
    corporateCultureDesc: '企業文化',
    esg: 'ESG',
    companyIntro: '企業簡介',
    corporateVideo: '企業視頻',
    videoNotSupported: '您的瀏覽器不支持Video標籤。',
    vision: {
      title: '願景',
      content: '成為國際一流的<br>模擬器件和數模混合<br>芯片公司'
    },
    mission: {
      title: '使命',
      content: '專注信息與能源<br>讓生活更美好、更高<br>效'
    },
    values: {
      title: '價值觀',
      content: '客戶:以客戶為中心<br>創新:持續創新<br>卓越:追求卓越<br>奮進:以奮鬥者為基,以進擊者為榮'
    }
  },
  products: {
    title: '產品中心'
  },
  footer: {
    productCenter: '產品中心',
    productApplication: '產品應用',
    qualityManagement: '質量管理',
    aboutYaoxin: '關於瑤芯',
    contactUs: '聯繫我們',
    slogan: '共創智能與可持續的未來',
    siliconPower: '硅功率器件',
    sicPower: '碳化硅功率器件',
    memsSensor: 'MEMS傳感器',
    signalChain: '信號鏈芯片',
    automotive: '汽車',
    greenEnergy: '綠色能源',
    communication: '通信',
    highPerformanceComputing: '高性能計算',
    industry: '工業',
    smartLife: '智能生活',
    qualityPolicy: '質量方針',
    qualityCert: '質量體系認證證書',
    totalQuality: '全面質量管理',
    contactMethod: '聯繫方式',
    salesNetwork: '銷售網絡',
    feedback: '留言反饋',
    privacyPolicy: '隱私政策',
    copyright: '版權所有 © 2024 瑤芯微（上海）電子科技股份有限公司'
  },
  contact: {
    title: '聯繫我們',
    subtitle: '歡迎與我們取得聯繫',
    returnHome: '返回首頁',
    leaveMessage: '給我們留言',
    leaveMessageDesc: '如有問題與建議，請填寫下方表格聯繫我們。我們會在24小時內答復您。',
    form: {
      name: '您的姓名*',
      phone: '您的手機號*',
      company: '您的公司名稱',
      email: '您的郵箱',
      message: '留言*',
      submit: '立即提交',
      readAgreement: '我已閱讀',
      userAgreement: '用戶使用協議',
      privacyPolicy: '隱私政策'
    },
    validation: {
      enterName: '請填寫聯繫人姓名',
      enterPhone: '請填寫聯繫電話',
      invalidPhone: '不是手機號碼',
      enterCompany: '請填寫公司名稱',
      enterMessage: '請填寫留言內容',
      checkAgreement: '請勾選我已閱讀用戶使用協議',
      confirmSubmit: '確認提交留言',
      submitSuccess: '留言成功,我們會盡快聯繫您!',
      submitFailed: '提交失敗，請稍後重試。'
    },
    labels: {
      contact: '聯繫人：',
      phone: '電話：',
      email: '郵箱：',
      address: '地址：'
    },
    cities: {
      shanghai: {
        name: '上海'
      },
      shenzhen: {
        name: '深圳'
      },
      xian: {
        name: '西安'
      },
      chengdu: {
        name: '成都'
      }
    }
  },
  investor: {
    download: '下載',
    noData: '暫無數據',
    view: '查看',
    viewDetail: '查看詳情',
    viewFile: '查看文件',
    disclosure: '信息披露',
    governanceTitle: '企業管治',
    stockInfo: '股票信息',
    investorLog: '投資者日誌',
    investorContact: '投資者關係聯絡',
    title: '投資者關係',
    subtitle: 'Investor Relations',
    breadcrumbHome: '首頁',
    breadcrumbInvestor: '投資者關係',
    query: '查詢',
    meetingRegistration: '點擊進入會議註冊及網絡廣播',
    pageTitles: {
      disclosure: '信息披露',
      governance: '企業管治',
      stockInfo: '股票信息',
      investorLog: '投資者日誌',
      investorContact: '投資者關係聯絡'
    },
    subNav: {
      prospectus: '招股文件',
      reports: '業績報告',
      announcements: '公告及通函',
      presentations: '推介會材料',
      emails: '電郵通知'
    },
    columns: {
      hShares: 'H股',
      otherDocuments: '其他文檔'
    },
    icons: {
      expand: '展開',
      collapse: '收起',
      search: '搜索',
      date: '日期',
      report: '報告'
    },
    search: {
      placeholder: '請輸入關鍵詞搜索'
    },
    contact: {
      title: '投資者關係聯絡',
      department: '投資者關係部門',
      workingHours: '工作時間',
      onlineConsultation: '在線諮詢',
      form: {
        name: '姓名',
        email: '郵箱',
        phone: '電話',
        message: '諮詢內容',
        submit: '提交'
      },
      address: '地址',
      email: '電子郵件',
    },
    governance: {
      companyStructure: '公司架構',
      boardCommittees: '董事會委員會',
      directorsSupervisors: '董事、監事及高級管理人員',
      companyStructureTitle: '公司架構',
      companyStructureDesc: '公司組織架構圖',
      executiveDirectors: '執行董事',
      nonExecutiveDirectors: '非執行董事',
      independentDirectors: '獨立非執行董事',
      auditCommittee: '審計委員會',
      remunerationCommittee: '薪酬委員會',
      nominationCommittee: '提名委員會',
      corporateGovernanceCommittee: '企業管治委員會',
      chairman: '主席',
      governanceDocuments: '治理文件'
    }
  },
  product: {
    downloadMerged: '下載合併文檔',
    downloadFailed: '下載失敗',
    selectAtLeastOneDoc: '請至少選擇一個文檔',
    noDataToExport: '暫無數據可導出',
    exportFailed: '導出失敗',
    returnToList: '返回列表',
    returnToDirectory: '返回目錄',
    signalChainChips: '信號鏈芯片',
    audioSignalChainChips: '音頻信號鏈芯片',
    productCenter: '產品中心',
    title: '標題',
    type: '類型',
    date: '日期',
    document: '文檔',
    selectAll: '全選',
    productParams: '產品參數',
    technicalDocs: '技術文檔',
    clickPartNumber: '點擊料號名稱可查看詳細資料',
    noCategoryInfo: '暫無該類別的信息',
    select: '選擇',
    reset: '重置',
    exportTable: '導出選型表格',
    learnMore: '進一步了解',
    selectAtLeastOne: '請至少選擇一個產品',
    selectAtLeastOneDoc: '請至少選擇一個文檔',
    productsDescription: '瑤芯致力於功率器件、智能傳感器和信號鏈芯片的設計、研發和銷售，主營產品為全品類功率器件（SiC MOS、IGBT、SJ MOS以及中低壓MOS）、MEMS傳感器以及信號鏈芯片。',
    loading: '加載中...',
    audioSignalChainTitle: '音頻信號鏈芯片',
    audioSignalChainDescription: '瑤芯以MEMS麥克風為抓手，構建了從信號採集（MEMS Sensor），信號轉化（聲信號轉電信號），信號處理(放大/濾波等)，音頻算法（上行/下行），模數轉換（ADC），數模轉換(DAC)，功放(PA)等音頻信號鏈全過程的開發能力，提供高性能的音頻信號鏈全鏈條解決方案。'
  },
  application: {
    application: '應用',
    diagram: '框圖',
    relatedProducts: '相關產品',
    noApplicationContent: '暫無應用內容',
    noDiagramContent: '暫無框圖內容',
    noRelatedProducts: '暫無相關產品',
    productApplication: '產品應用'
  },
  news: {
    returnToList: '返回列表',
    returnHome: '返回首頁'
  },
  quality: {
    policy: {
        titleEn: 'Quality Policy',
        titleZh: '質量方針',
        subtitle: '瑤芯始終堅持以創新的設計和高質量的產品為根基，推行全面質量管理，恪守承諾，追求卓越。',
        content: '<p>該方針是我公司經營方針的重要組成部分，與組織的宗旨和環境相適應並支持其戰略性方向；提供設定質量目標的框架；包括滿足相關要求的承諾；包括持續改進質量管理體系的承諾。各級領導要將質量方針傳達到管理、執行、驗證和作業等層次人員，使全體員工正確理解並堅決執行。</p>'
    },
    system: {
        titleEn: 'Quality System',
        titleZh: '質量體系認證證書',
        content: '<p>瑤芯始終追求質量管理體系的最高標準。瑤芯微作為知名設計公司的地位堅定不移，並獲得了 ISO9001（質量體系管理）和 ISO26262（功能安全管理）的質量認證。</p>',
        partnerTitle1: '我們的協作戰略製造合作夥伴',
        partnerTitle2: '還滿足以下管理體系標準：'
    },
    certificates: {
        iso9001: '質量體系管理',
        iatf16949: '汽車質量體系管理',
        iso14001: '環境管理體系',
        qc080000: '有害物質過程管理',
        iso45001: '職業安全與健康管理'
    },
    tqm: {
        titleEn: 'TQM',
        titleZh: '全面質量管理',
        content: '<p>正如我們的質量政策所涵義的那樣，Alkaidsemi 採用全面質量管理（TQM）方法，通過客戶滿意度取得長期成功。我們組織的所有成員都參與改進我們工作的流程、產品、服務和文化。</p>'
    }
  },
  search: {
    title: '搜索',
    searchTitle: '搜索',
    breadcrumbProducts: '產品中心',
    select: '選擇',
    download: '下載',
    noResults: '未找到相關產品',
    loading: '加載中...',
    totalResults: '共找到 {total} 條結果',
    pageSize: '每頁條數',
    prevPage: '上一頁',
    nextPage: '下一頁',
    jumpTo: '跳轉到',
    confirm: '確認',
    headers: {
      subject: '料號',
      status: '狀態',
      spiceModel: 'Spice Model',
      package: '封裝',
      cfg: 'Cfg',
      vds: 'VDS(V)',
      vgs: 'Vgs(V)',
      ida: 'ID(A)',
      vth: 'Vth(V)',
      typ10: 'Typ@10V',
      max10v: 'Max@10V',
      typ45: 'Typ@4.5V',
      max45: 'Max@4.5V',
      ciss: 'CISS_Typ(pF)',
      coss: 'COSS_Typ(pF)',
      crss: 'CRSS_Typ(pF)',
      qgnc: 'QG_Typ(nC)',
      pic2: '數據手冊',
      spice_model: 'Spice Model'
    }
  },
  login: {
    title: '瑤芯微電子人員登錄',
    emailOrUsername: '郵箱/用戶名',
    passwordPlaceholder: '請輸入密碼',
    captchaPlaceholder: '請輸入驗證碼',
    loginButton: '登錄',
    enterUsername: '請輸入用戶名',
    enterPassword: '請輸入密碼',
    enterCaptcha: '請輸入驗證碼',
    loginFailed: '登錄失敗，請稍後重試',
    loginError: '用戶名或密碼錯誤！',
    apiNotConfigured: '登錄功能需要後端API支持，請聯繫開發人員配置登錄接口'
  },
  senior: {
    guo: {
      name: '郭亮良',
      position: '董事長/總經理',
      desc: [
        '• 國家科技創業領軍人才',
        '• 曾任中芯國際技術開發資深經理、華虹NEC高壓器件和BCD研發主管',
        '• 18年半導體技術開發經驗，師從中國第三代半導體領軍專家郝躍院士'
      ]
    },
    chen: {
      name: '陳開宇',
      position: '功率產品線負責人',
      desc: [
        '• 21年行業經驗，曾擔任Diodes全球 MOSFET事業部總經理，豐富的車載及高端功率器件開發經驗'
      ]
    },
    wang: {
      name: '王一鳴',
      position: 'IC產品線負責人',
      desc: [
        '• 18年電源領域模擬芯片開發和產品經驗，曾任職 MPS工程產品部主管'
      ]
    },
    wangqs: {
      name: '王青松',
      position: '音頻產品線負責人',
      desc: [
        '• 18年音頻信號鏈IC開發和產品經驗',
        '• 曾任全志科技芯片研發中心技術總監、華為海思麒麟芯片音頻信號鏈研發負責人'
      ]
    },
    li: {
      name: '李衛剛',
      position: '運營負責人',
      desc: [
        '• 20年行業經驗，曾擔任華虹宏力功率器件工程主管，中芯國際傳感器研發主管，熟悉傳感器市場和功率器件市場，熟悉FAB和OSAT運營管理'
      ]
    },
    zheng: {
      name: '鄭召星',
      position: '質量負責人',
      desc: [
        '• 22年行業經驗，曾擔任中芯國際工藝整合總監，華力微工藝整合部部長，服務過頂尖客戶群，精通FAB工程和量產管理'
      ]
    },
    luo: {
      name: '羅希',
      position: '華東/車載銷售',
      desc: [
        '• 23年行業經驗，曾擔任英飛凌車載事業部資深銷售總監，負責ATV所有產品的銷售和代理商管理，精通車載市場和整車廠'
      ]
    },
    huang: {
      name: '黃冬榆',
      position: '華南銷售',
      desc: [
        '• 23年行業經驗，曾擔任IR大中華區銷售主管，英飛凌PSS事業部銷售主管，熟悉電力電子驅動和功率器件市場'
      ]
    },
    zhu: {
      name: '朱魏清',
      position: '音頻銷售',
      desc: [
        '• 25年半導體從業經驗，曾擔任CECport市場副總裁，Arrow中國區市場總監，熟悉半導體市場和客戶群'
      ]
    }
  }
}

